import { create } from 'zustand';

interface SettingsState {
  settings: Record<string, any>;
  setSettings: (settings: Record<string, any>) => void;
  getSetting: (key: string, defaultValue?: any) => any;
}

export const useSettingsStore = create<SettingsState>((set, get) => ({
  settings: {},
  setSettings: (settings) => set({ settings }),
  getSetting: (key, defaultValue = null) => {
    const { settings } = get();
    return settings[key] !== undefined ? settings[key] : defaultValue;
  },
}));
